export default {
  reset(state) {
    state.messages = [];
  },

  add(state, payload) {
    state.messages.push(payload);
  },

  remove(state, idx) {
    state.messages.splice(idx, 1);
  }
};
